import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './normalize.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as configured from './store/configureStore';
// module.exports = require('./config/home-config.json')
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(<App {...configured} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
